import {
  GeneralPrintResponseModel,
  SalesInGraphReportSearchParamsModel,
  SalesInGraphReportSearchParamsStringModel,
  ResponseBaseModel,
  TransactionReportSearchParamsModel,
  EmployeeSalesCommissionReportSearchParamsModel,
  EmployeeSalesCommissionReportSearchParamsStringModel,
} from "../models";
import AlYusrAxiosApiInstance, {
  AxiosSearchParams,
} from "../axios/alYusrAxiosApiInstance";
import { AlYuserApiUrls } from "../configuration";
import { formatToIsoString } from "../utils";
//#region get
export const SearchReportEmployeeEsthkakSubtracts = async (
  request: SalesInGraphReportSearchParamsModel
): Promise<ResponseBaseModel<GeneralPrintResponseModel>> => {
  let req: SalesInGraphReportSearchParamsStringModel = {
    Lang: request?.Lang,
    userId: request?.userId,
  };
  req.fromDate = formatToIsoString(request?.fromDate ?? "");
  req.toDate = formatToIsoString(request?.toDate ?? "");
  return await AlYusrAxiosApiInstance.get(
    AlYuserApiUrls.employeeReportController.reportEmployeeEsthkakSubtracts,
    {
      params: AxiosSearchParams(req, "searchParmeter"),
    }
  );
};
export const SearchReportEmployeeSalesPage = async (
  request: TransactionReportSearchParamsModel
): Promise<ResponseBaseModel<GeneralPrintResponseModel>> => {
  return await AlYusrAxiosApiInstance.get(
    AlYuserApiUrls.employeeReportController.reportEmployeeCashierSales,
    {
      params: AxiosSearchParams(request, "searchParmeter"),
    }
  );
};
export const searchReportEmployeeSalesCommission = async (
  request: EmployeeSalesCommissionReportSearchParamsModel
): Promise<ResponseBaseModel<GeneralPrintResponseModel>> => {
  let req: EmployeeSalesCommissionReportSearchParamsStringModel = {
    Lang: request?.Lang,
    userId: request?.userId,
    categoryId: request?.calcTypeId,
    itemId: request?.itemId,
    calcTypeId: request?.calcTypeId,
    employeeId: request?.employeeId,
    custmerId: request?.custmerId,
    currencyId: request?.currencyId,
    code: request?.code,
  };
  req.fromDate = formatToIsoString(request?.fromDate ?? "");
  req.toDate = formatToIsoString(request?.toDate ?? "");
  return await AlYusrAxiosApiInstance.get(
    AlYuserApiUrls.employeeReportController.reportEmployeeSalesComission,
    {
      params: AxiosSearchParams(req, "searchParmeter"),
    }
  );
};
//#endregion
